import type { i18n as I18nInstance } from 'i18next';
import type { QuestionConfigQuestionType } from '/index';

import FlameIcon from '/business/shared/images/icons/icon-flame.svg';
import { questionScopeCategories } from '/business/shared/util/Statics';
import educationContentJson from '/business/shared/components/questions/scope3/_education/phantomFuelAndEnergy.json';

export const getConfigurePhantomFuelAndEnergy = ({ i18n }: { i18n: I18nInstance }): QuestionConfigQuestionType => {
  return {
    id: 'fuel-and-energy-related',
    apiKey: 'calculation-fuel-and-energy-related',
    isCompletePropName: 'isPhantomFuelAndEnergyComplete',
    scopeCategory: questionScopeCategories.SCOPE_3,
    title: i18n.t('business:QuestionPage.forms.phantom.fuelAndEnergy.title'),
    primaryI18nKey: 'business:QuestionPage.forms.phantom.fuelAndEnergy.title', // question selection step title
    subTextI18nKey: 'business:QuestionPage.forms.phantom.fuelAndEnergy.subtitle', // question selection step subtitle
    overviewPageTitleI18nKey: 'business:QuestionPage.forms.phantom.fuelAndEnergy.title',
    icon: FlameIcon,
    form: import('/business/shared/components/questions/scope3/OutOfSys_WTT_display'),
    hasSidebar: false,
    education: {
      hasEducationWidget: true,
      educationContent: educationContentJson,
      hasNoBottomSection: true,
    },
  };
};
